function Column({ children }) {
  return (
    <div className='flex flex-column items-stretch flex-grow-1 mh1 w-100'>
      {children}
    </div>
  );
}

export default Column;
